<template>
	<div class="active-mode">
		<v-autocomplete
			filled
			dense
			return-object
			v-model="value"
			:items="acItems"
			item-value="value"
			item-text="option"
			:loading="loadingItems"
			:search-input.sync="search"
			:multiple="false"
			placeholder="Choose sample data"
			:error-messages="selectedCustomError"
		>
			<template #item="{ item }">
				<SearchFieldListItem :item="item" :isMultipleSelection="false" :value="{}" />
			</template>

			<template #selection="data">
				<SearchFieldSelectedItem :data="data" :isMultipleSelection="false" />
			</template>

			<template #append-item v-if="hasMoreData">
				<Loader v-show="loadingItems" />
				<div v-if="page > 2" class="text-center" v-show="!loadingItems">You've reached the limit</div>
				<v-btn v-else @click="loadMore" class="text-center load-more-btn" v-show="!loadingItems">Load more...</v-btn>
			</template>
			<template #no-data v-if="errorMessage">
				<v-list-item>
					<span class="error-message">
						{{ errorMessage }}
					</span>
				</v-list-item>
			</template>
		</v-autocomplete>
	</div>
</template>

<script>
import api from '@/api';
import pagination from '@/api/pagination';
import WidgetFieldMixin from '../../WidgetFields/WidgetFieldMixin';
import SearchFieldMixin from '../../WidgetFields/SearchField/SearchFieldMixin';
export default {
	name: 'SearchFieldForCustomSettings',
	components: {},
	props: {},
	mixins: [WidgetFieldMixin, SearchFieldMixin],
	computed: {
		value: {
			get() {
				return this.fieldOptions.custom?.sample?.value;
			},
			set(value) {
				this.preventNextSearchCall = true;
				if (!this.fieldOptions.custom.sample) {
					this.$emit('updateLocalField', { key: 'metadata.options.custom.sample', value: { value: undefined } });
				}
				this.$emit('updateLocalField', { key: 'metadata.options.custom.sample.value', value });
			},
		},
		fieldSourceURL() {
			return this.field.source_url;
		},
		selectedCustomError() {
			if (this.fieldOptions.custom?.sample?.value && !this.fieldOptions.custom?.sample?.value?.item) {
				return 'This app does not support custom values';
			}
			return undefined;
		},
	},
	methods: {
		async loadMenuItems() {
			if (!this.fieldSourceURL) {
				return;
			}
			this.loadingItems = true;
			this.errorMessage = null;
			const addFullItem = true;
			const res = await api.queryAC(this.fieldSourceURL, this.search, this.page, this.retrievalId, addFullItem);
			this.loadingItems = false;
			const response = pagination.consolidateQueryACResponse(res);
			if (response.errorMessage) {
				this.hasMoreData = false;
				this.errorMessage = response.errorMessage;
				this.$set(this, 'acItems', []);
				this.value = { value: '', option: '' };
				return;
			}

			this.hasMoreData = response.hasMoreData;
			this.retrievalId = response.retrievalId;
			if (this.page === 1) {
				this.$set(this, 'acItems', response.results);
			} else {
				this.acItems.push(...response.results);
			}
		},
	},
	data() {
		return {
			page: 1,
			acItems: [],
			search: null,
			retrievalId: null,
			errorMessage: null,
			hasMoreData: false,
			loadingItems: false,
			preventNextSearchCall: false,
		};
	},
	created() {
		this.loadMenuItems();
	},
};
</script>
<style scoped lang="scss">
.not-supported-message {
	font-size: small;
	color: red;
}
.load-more-btn {
	width: 100%;
}
</style>
